<div class="billing a-fx-col" [class.billing-new]="newCustomer">
    <div class="a-fx-none a-fx-col a-fx-gap-32" [ngClass]="newCustomer ? 'a-fx-gap-32' : 'a-fx-gap-24'">
        <div class="h3">
            {{ 'settings.billing-information' | translate }}
        </div>

        <p [innerHTML]="'settings.billing.info' | translate"></p>
    </div>

    <form
        *ngIf="billingForm$ | async as billingForm"
        nz-form
        [formGroup]="billingForm"
        class="billing-form adspt-form ant-row"
    >
        <nz-form-item adsptFormInputStates class="ant-col ant-col-xs-12 ant-col-md-12">
            <nz-form-label>{{ 'settings.billing.company' | translate }}*</nz-form-label>

            <nz-form-control [nzErrorTip]="'settings.billing.name-error' | translate">
                <input nz-input formControlName="name" placeholder="John Doe" />

                <ng-container *ngTemplateOutlet="errorIcon"></ng-container>
            </nz-form-control>
        </nz-form-item>

        <nz-form-item class="ant-col ant-col-xs-12 ant-col-md-12">
            <nz-form-label>{{ 'settings.billing.mail' | translate }}*</nz-form-label>

            <nz-form-control [nzErrorTip]="'settings.billing.mail-error' | translate" [nzAutoTips]="">
                <input nz-input formControlName="email" placeholder="hello@contoso.com" />

                <ng-container *ngTemplateOutlet="errorIcon"></ng-container>
            </nz-form-control>
        </nz-form-item>

        <nz-form-item adsptFormInputStates class="ant-col ant-col-xs-12 ant-col-md-12">
            <nz-form-label>{{ 'settings.billing.address1' | translate }}*</nz-form-label>

            <nz-form-control [nzErrorTip]="'settings.billing.address1-error' | translate">
                <input nz-input formControlName="address1" placeholder="EG 4, Berliner st 22" />

                <ng-container *ngTemplateOutlet="errorIcon"></ng-container>
            </nz-form-control>
        </nz-form-item>

        <nz-form-item adsptFormInputStates class="ant-col ant-col-xs-12 ant-col-md-12">
            <nz-form-label
                >{{ 'settings.billing.address2' | translate }} ({{ 'common.optional' | translate }})</nz-form-label
            >

            <nz-form-control>
                <input nz-input formControlName="address2" placeholder="near bahnhof" />

                <ng-container *ngTemplateOutlet="errorIcon"></ng-container>
            </nz-form-control>
        </nz-form-item>

        <nz-form-item adsptFormInputStates class="ant-col ant-col-xs-12 ant-col-md-12 ant-col-lg-6">
            <nz-form-label>{{ 'settings.billing.zipcode' | translate }}*</nz-form-label>

            <nz-form-control [nzErrorTip]="'settings.billing.zipcode-error' | translate">
                <input nz-input type="text" formControlName="zip" placeholder="00000" />

                <ng-container *ngTemplateOutlet="errorIcon"></ng-container>
            </nz-form-control>
        </nz-form-item>

        <nz-form-item adsptFormInputStates class="ant-col ant-col-xs-12 ant-col-md-12 ant-col-lg-6">
            <nz-form-label>{{ 'settings.billing.city' | translate }}*</nz-form-label>
            <nz-form-control [nzErrorTip]="'settings.billing.city-error' | translate">
                <input nz-input formControlName="city" placeholder="Berlin" />

                <ng-container *ngTemplateOutlet="errorIcon"></ng-container>
            </nz-form-control>
        </nz-form-item>

        <nz-form-item
            adsptFormInputStates
            class="ant-col ant-col-xs-12 ant-col-md-12 ant-col-lg-6 country-autocomplete"
            formGroupName="country"
        >
            <nz-form-label>{{ 'settings.billing.country' | translate }}*</nz-form-label>

            <nz-form-control [nzErrorTip]="'settings.billing.country-error' | translate">
                <nz-select
                    nzShowSearch
                    nzNoAnimation
                    nzAutoClearSearchValue
                    nzPlaceHolder="Germany"
                    formControlName="code"
                    [nzCustomTemplate]="countryOptionTmpl"
                    [nzSuffixIcon]="suffixTemplate"
                >
                    <nz-option
                        *ngFor="let country of countries"
                        nzCustomContent
                        [nzValue]="country.value"
                        [nzLabel]="country.text"
                    >
                        <div class="a-fx a-fx-start-center a-fx-gap-16">
                            <ng-container
                                *ngTemplateOutlet="countryFlagTmpl; context: { $implicit: country.value }"
                            ></ng-container>

                            <div>{{ country.text }}</div>
                        </div>
                    </nz-option>
                </nz-select>

                <ng-template #countryOptionTmpl let-country>
                    <div *ngIf="country.nzValue as countryCode" class="a-fx a-fx-start-center a-fx-gap-16">
                        <ng-container
                            *ngTemplateOutlet="countryFlagTmpl; context: { $implicit: countryCode }"
                        ></ng-container>

                        <div>{{ getCountryFromValue(countryCode)?.text }}</div>
                    </div>
                </ng-template>

                <ng-template let-countryCode #countryFlagTmpl>
                    <img *ngIf="countryCode" src="{{ flagsUrl + countryCode + '.png' }}" class="flag" />
                </ng-template>

                <ng-container *ngTemplateOutlet="errorIcon"></ng-container>
            </nz-form-control>
        </nz-form-item>

        <nz-form-item adsptFormInputStates class="ant-col ant-col-xs-12 ant-col-md-12 ant-col-lg-6">
            <nz-form-label>{{ 'settings.billing.invoice-lang' | translate }}</nz-form-label>

            <nz-form-control>
                <nz-select formControlName="invoiceLanguage" [nzSuffixIcon]="suffixTemplate">
                    <nz-option
                        *ngFor="let language of languageSelectOptions"
                        [nzValue]="language.value"
                        [nzLabel]="language.text"
                    ></nz-option>
                </nz-select>
            </nz-form-control>
        </nz-form-item>

        <nz-form-item
            adsptFormInputStates
            class="ant-col ant-col-xs-12 ant-col-md-12 ant-col-lg-6"
            formGroupName="country"
        >
            <nz-form-label class="vat-label">
                <div class="a-fx a-fx-start-center a-fx-gap-4">
                    <div>
                        {{ 'settings.billing.vat' | translate
                        }}<ng-container *ngIf="vatRequired$ | async">*</ng-container>
                    </div>

                    <div *ngIf="!(vatRequired$ | async)">({{ 'common.optional' | translate }})</div>
                </div>
            </nz-form-label>
            <nz-form-control
                [nzErrorTip]="'settings.billing.vat-error' | translate"
                [nzValidateStatus]="billingForm.get('country')"
            >
                <input nz-input formControlName="vatId" placeholder="0000000" />

                <ng-container *ngTemplateOutlet="errorIcon"></ng-container>
            </nz-form-control>
        </nz-form-item>

        <nz-form-item adsptFormInputStates class="ant-col ant-col-xs-12 ant-col-md-12 ant-col-lg-6">
            <nz-form-label
                >{{ 'settings.billing.order-no' | translate }} ({{ 'common.optional' | translate }})</nz-form-label
            >

            <nz-form-control>
                <input nz-input formControlName="orderNumber" placeholder="89449849-5489" />
            </nz-form-control>
        </nz-form-item>

        <ng-template #errorIcon>
            <i class="adspt-error-icon">
                <svg class="adspt-icon icon-error">
                    <use xlink:href="#adspt-error"></use>
                </svg>
            </i>
        </ng-template>

        <ng-template #suffixTemplate>
            <i nz-icon>
                <adspt-icon name="caret-down" />
            </i>
        </ng-template>
    </form>
</div>

<ng-container
    adsptHeap="subscription-billing-save"
    [useParent]="true"
    [debounceResolve]="true"
    [elementPath]="{ parent: '.ant-modal-content', child: '.ant-modal-footer .ant-btn-primary' }"
/>
<ng-container
    adsptHeap="subscription-billing-cancel"
    [useParent]="true"
    [debounceResolve]="true"
    [elementPath]="{ parent: '.ant-modal-content', child: '.ant-modal-footer .ant-btn' }"
/>
